<template>
  <div class="px-2 my-4 bg-grey-lighter border rounded ">
    <div class="pt-4 px-2">
      <div class="text-lg font-black py-2">Action Points</div>
      <div class="w-full" v-if="additionalActions && additionalActions.length">
        <div v-for="(item, index) in this.additionalActions" :key="index" class="pt-4 flex" v-if="item.page === page">
          <textarea class="w-full py-2 px-3 border-2 rounded bg-white outline-none"
                    v-model="item.value" :ref="'action'+index" :rows="2" :id="'action'+index" />
          <div class="flex w-1/4 items-center justify-between">
            <div class="pr-4">
              <input type="radio"  :id="page+'_agent_'+index" :name="page+'_action_'+index" value="agent" v-model="item.follow_by" style="width:50px; height: 20px;">
              <label :for="page+'_agent_'+index" class="ml-4 mt-2">Agent</label>
            </div>
            <div class="pr-4">
              <input type="radio"  :id="page+'_guild_'+index" :name="page+'_action_'+index" value="guild" v-model="item.follow_by" style="width:50px; height: 20px;">
              <label :for="page+'_guild_'+index" class="ml-4 mt-2">Guild</label>
            </div>
            <i class="fas fa-trash mr-4 cursor-pointer" @click="removeAction(index)" title="Remove this additional action"></i>
          </div>
        </div>
      </div>
      <div v-if="(!actions || !actions.length) && (!additionalActions || !additionalActions.length)" class="py-4" >
        No action added yet. Please click the add button to add a new action point.
      </div>
    </div>

    <div class="py-4">
      <div class="text-green text-lg cursor-pointer" @click="addActions">+ Add an action point</div>
    </div>
  </div>
</template>

<script>
import ErrorBag from '@/ErrorBag'

export default {
  props: ['value', 'review', 'page'],
  data: function () {
    return {
      form: this.value,
      newNum: 0,
      actions: [],
      additionalActions: this.review.additionalActions,
      errorBag: new ErrorBag()
    }
  },
  methods: {
    addActions () {
      this.additionalActions.push({ 'value': '', 'page': this.page, 'follow_by': 'agent' })
    },
    removeAction (index) {
      this.additionalActions.splice(index, 1)
    }
  }
}
</script>
